import { useCallback } from 'react';
import { UseFormSetFocus, UseFormSetValue } from 'react-hook-form';
import { Contact } from '../../../components/address-book';
import { AddressForm, AddressTypeCode } from '../../../global-types/addresses';
import { EnvelopeType } from '../../../global-types/envelope';

type AssignFormProps = {
  handleSetFormValue: UseFormSetValue<AddressForm>;
  handleSetFocus: UseFormSetFocus<AddressForm>;
  contact: Contact | undefined | null;
  addressTypeCode: AddressTypeCode;
  selectedEnvelope: EnvelopeType;
};
type AssignFromFn = (params: AssignFormProps) => void;

export const useNavigationForward = () => {
  // assignForm is used to update the form values when the user clicks on the forward button
  // and takes the form data from the 1:M context
  const assignForm: AssignFromFn = useCallback(
    ({ handleSetFormValue, handleSetFocus, contact, addressTypeCode, selectedEnvelope }) => {
      const options = { shouldValidate: true, shouldDirty: true };

      handleSetFormValue('address_id', contact?.contact_id || '', options);
      handleSetFormValue('first_name', contact?.first_name || '', options);
      handleSetFormValue('last_name', contact?.last_name || '', options);
      handleSetFormValue('address_line_1', contact?.address_line_1 || '', options);
      handleSetFormValue('address_line_2', contact?.address_line_2 || '', options);
      handleSetFormValue('company_name', contact?.company_name || '', options);
      handleSetFormValue('city', contact?.city || '', options);
      handleSetFormValue('state_code', contact?.state_code || '', options);
      handleSetFormValue('zip', contact?.zip || '', options);
      handleSetFormValue('country_code', contact?.country_code || 'USA', options);
      handleSetFormValue('skip_usps_validation', true, options);
      handleSetFormValue('address_type_code', addressTypeCode, options);
      handleSetFormValue('envelope', selectedEnvelope, options);

      handleSetFocus('first_name');
    },
    [],
  );

  return { assignForm };
};
